import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { type SuccessResponse } from '@vestigas/data';

import { resetSignatureRoles } from './resetSignatureRoles';

/**
 * Custom hook for resetting all users of a company account to its configured
 * default signature role.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin/operation/reset_company_account_signature_roles_vadmin_company_account__company_account_uuid__reset_signature_roles_post
 */
export const useMutationResetSignatureRoles = (
  options?: Omit<
    UseMutationOptions<SuccessResponse, Error, UUID>,
    'mutationFn'
  >,
) => {
  return useMutation<SuccessResponse, Error, UUID>({
    mutationFn: resetSignatureRoles,
    ...options,
  });
};
